module.exports = __webpack_public_path__ + "static/2-a1be94c7394f664d8051cb8398ebffa6.png";